<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="25">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch"
                    :colSpan="4" />
                </Col>
            </Row>
        </transition>

        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="25">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">定金单废单</span>
						<span style="margin-left:20px;">会员类别:</span>
						<RadioGroup v-model="userType"
						    style="margin-left:4px;"
						    @on-change="onUserTypeChage">
						    <Radio label="F"> <span>外部会员</span></Radio>
						    <Radio label="E"> <span>内部会员</span></Radio>
						</RadioGroup>
                    </div>
                    <div class="right-bar">
                        <Button type="info"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            :loading="btnLoading"
                            @click="onExport()">导出</Button>

                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="25">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :extHeight="60"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <AbandonedDepositDetail ref="AbandonedDepositDetailModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import AbandonedDepositDetail from '@/view/sale-management/abandoned/abandoned-deposit-detail';
import { remarkOrderdeposite, paybackOrderdeposite, exportPreSaleOrderList, repayOrderdeposite } from '@/api/modules/preSale-management/preSale-order';
import { getOldDepositBillOrderList, cancleDepositBillRecordByUuid, closeDepositBillRecordByUuid } from '@/api/modules/preSale-management/deposit-order';
import {
    getOrderDeliveryStatusOptions,
    getOrderPaidStatusOptions
} from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import { numberToFixed } from '@/components/number-input/display-format';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
import { SignContractForUser } from '@/api/modules/system-management/user-management';

export default {
    name: 'AbandonedDepositList',
    components: {
        StandPaginationTable,
        SearchCard,
        AbandonedDepositDetail
    },
    data() {
        return {
            userType:'F',
            btnLoading: false,
            mainTable: {
                tableColumns: [
                    { title: '废单编号', key: 'depositBillRecordCodeOld', align: 'center', width:146 },
                    { title: '关联定金单', key: 'depositBillRecordCode', align: 'center', width:150 },
                    { title: '会员名称', key: 'userPersonName', align: 'center' },
                    { title: '会员账号', key: 'userName', align: 'center' },
                    { title: '会员电话', key: 'userPhone', align: 'center' },
                    { title: '客户经理', key: 'customerManagername', align: 'center' },
                    { title: '定单合计', key: 'depositBillRecordTotalOrderCost', align: 'center' },
                    { title: '已付定金', key: 'depositBillRecordDepositPaymentSum', align: 'center' },
                    { title: '定单周期', key: 'weekDesc', align: 'center' },
                    { title: '下单时间', key: 'depositBillRecordCreateAt', sortable: true, align: 'center', render: (h, params) => dateTimeRender(h, params.row.depositBillRecordCreateAt) },
                    { title: '客户备注', key: 'customerMsg', align: 'center' },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                            visibility: params.row.customerManagername=='合计'? 'hidden' : 'visible'
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.AbandonedDepositDetailModal.showModal(params.row.depositBillRecordUuid);
                                            }
                                        }
                                    }, '查看')
                                ]);
                            }
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: true,
                searchForm: [
                    { label: '废单编号', type: 'Input', value: '', name: 'depositBillRecordCode', sql: 'like' },
                    { label: '定金单编号', type: 'Input', value: '', name: 'depositBillRecordCode', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(userPersonName,userName,userPhone)', sql: 'like' },
                    { label: '下单时间', type: 'Daterange', value: '', name: 'depositBillRecordCreateAt', sql: 'dateBetween' }
                ]
            }
        };
    },
    created() {
        if (this.$checkAccessArray(["B", "C", "S", "G"]) === false) {
            const findIndex = this.mainTable.tableColumns.findIndex(c => c.title === "操作");
            if (findIndex >= 0) {
                this.mainTable.tableColumns.splice(findIndex, 1);
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        onExport() {
            this.mainTable.tableLoading = true;
            this.btnLoading = true;
            exportPreSaleOrderList(this.mainTable.tableSearch).then(res => {
                this.btnLoading = false;
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                    }
                }
            });
        },
        onUserTypeChage(){
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            getOldDepositBillOrderList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    let depositBillRecordTotalOrderCostTotal = 0;
                    let depositBillRecordDepositPaymentSumTotal = 0;

                    this.mainTable.tableData.forEach(e => {
                        depositBillRecordTotalOrderCostTotal += e.depositBillRecordTotalOrderCost;
                        depositBillRecordDepositPaymentSumTotal += e.depositBillRecordDepositPaymentSum;
                    });
                    this.mainTable.tableData.push({
                        customerManagername: '合计',
                        depositBillRecordTotalOrderCost: numberToFixed(depositBillRecordTotalOrderCostTotal, 2),
                        depositBillRecordDepositPaymentSum: numberToFixed(depositBillRecordDepositPaymentSumTotal, 2),
                        action: 1
                    });
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
